import convertApi from "./portfolioApi";
import { createSlice } from "@reduxjs/toolkit";
import { createThunkFromApi } from "store/utils";

export const getPortfolioChartForm = createThunkFromApi(
  "convert/getPortfolioChartForm",
  convertApi.getPortfolioChartForm
);

export const getPortfolioChart = createThunkFromApi(
  "convert/getPortfolioChart",
  convertApi.getPortfolioChart
);

export const getPortfolioTradeAvgForm = createThunkFromApi(
  "convert/getPortfolioTradeAvgForm",
  convertApi.getPortfolioTradeAvgForm
);

export const getPortfolioInvestmentForm = createThunkFromApi(
  "convert/getPortfolioInvestmentForm",
  convertApi.getPortfolioInvestmentForm
);

export const getPortfolioTradeAvgList = createThunkFromApi(
  "convert/getPortfolioTradeAvgList",
  convertApi.getPortfolioTradeAvgList
);

export const getPortfolioInvestmentList = createThunkFromApi(
  "convert/getPortfolioInvestmentList",
  convertApi.getPortfolioInvestmentList
);

export const getPortfolioTradeAvgForCoinForm = createThunkFromApi(
  "convert/getPortfolioTradeAvgForCoinForm",
  convertApi.getPortfolioTradeAvgForCoinForm
);

export const getPortfolioTradeAvgForCoin = createThunkFromApi(
  "convert/getPortfolioTradeAvgForCoin",
  convertApi.getPortfolioTradeAvgForCoin
);

export const getPortfolioTradeAvgForCoinList = createThunkFromApi(
  "convert/getPortfolioTradeAvgForCoinList",
  convertApi.getPortfolioTradeAvgForCoinList
);

const initialState = {
  portfolioChartForm: null,
  portfolioChart: null,
  portfolioForm: null,
  portfolioTradeList: null,
  portfolioInvestmentList: null,
  portfolioSingleTrade: null,
  portfolioSingleTradeList: null
};

export const portfolioSlice = createSlice({
  name: "portfolio",
  initialState,

  extraReducers: {
    [getPortfolioChartForm.fulfilled]: (state, { payload }) => {
      state.portfolioChartForm = payload.data;
    },

    [getPortfolioChart.fulfilled]: (state, { payload }) => {
      state.portfolioChart = payload.data;
    },

    [getPortfolioTradeAvgForm.fulfilled]: (state, { payload }) => {
      state.portfolioForm = payload.data;
    },

    [getPortfolioInvestmentForm.fulfilled]: (state, { payload }) => {
      state.portfolioForm = payload.data;
    },

    [getPortfolioTradeAvgForCoinForm.fulfilled]: (state, { payload }) => {
      state.portfolioForm = payload.data;
    },

    [getPortfolioTradeAvgList.fulfilled]: (state, { payload }) => {
      state.portfolioTradeList = payload.data;
    },

    [getPortfolioInvestmentList.fulfilled]: (state, { payload }) => {
      state.portfolioInvestmentList = payload.data;
    },

    [getPortfolioTradeAvgForCoin.fulfilled]: (state, { payload }) => {
      state.portfolioSingleTrade = payload.data;
    },

    [getPortfolioTradeAvgForCoinList.fulfilled]: (state, { payload }) => {
      state.portfolioSingleTradeList = payload.data;
    },
  },
});

export default portfolioSlice.reducer;
